import { render, staticRenderFns } from "./txt.vue?vue&type=template&id=460d152a&scoped=true"
import script from "./txt.vue?vue&type=script&lang=js"
export * from "./txt.vue?vue&type=script&lang=js"
import style0 from "./txt.vue?vue&type=style&index=0&id=460d152a&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460d152a",
  null
  
)

export default component.exports